var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',[(_vm.form)?_c('v-container',{staticClass:"px-4",attrs:{"fluid":""}},[_c('v-row',[_vm._t("content",null,{"form":_vm.form})],2)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }